import React, { PureComponent } from 'react';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { Select } from 'antd';
import Big from 'big.js';
import classNames from 'classnames';

import { BaseInputProps } from '../types';
import { isEmpty, isNullLike } from '../utils';

import { Num } from './Num';

export interface TenorBucketHandlerListInfo {
  key?: string;
  value?: number;
}

export interface TenorBucketHandlerListProps extends BaseInputProps {
  value?: TenorBucketHandlerListInfo[];
  isPercentage?: boolean;
  onChange?: (val?: TenorBucketHandlerListInfo[]) => void;
}

export class TenorBucketHandlerList extends PureComponent<TenorBucketHandlerListProps> {
  value: TenorBucketHandlerListInfo[] = [];

  isEmptyItem = (item: TenorBucketHandlerListInfo) => {
    return isEmpty(item.key) && isNullLike(item.value);
  };

  onChange = (i: number, val: any, key?: keyof TenorBucketHandlerListInfo) => {
    const value = [...this.value];
    if (!value[i]) value[i] = { key: '' };
    if (key) value[i][key] = val as never;
    else value[i] = { ...value[i], ...val };

    this.props.onChange?.(
      value.length === 1 && this.isEmptyItem(value[0])
        ? []
        : value.filter(it => !!it.key),
    );
  };

  onAdd = (i: number) => {
    const value = [...this.value];
    value.splice(i + 1, 0, { key: '' });
    this.props.onChange?.(value);
    this.props.onBlur?.();
  };

  onDel = (i: number) => {
    const value = [...this.value];
    value.splice(i, 1);
    
    this.props.onChange?.(
      value.length === 1 && this.isEmptyItem(value[0]) ? [] : value,
    );
    this.props.onBlur?.();
  };

  render() {
    this.value = this.props.value || [];
    // if (!this.value.length && !this.props.readonly)
    //   this.value.push({ key: '' });
    return (
      <div
        className={classNames(
          this.props.className,
        )}
        style={this.props.style}
      >
        {this.props.readonly ? (
          this.props.value?.length ? (
            this.value
              .filter(it => it.key)
              .map((it, i) => (
                <>
                  <span key={i}>
                    {it.key}
                    {['Short', 'Long'].includes(it.key as string) ? ' Term' : ''}
                    <span>/</span>
                    {!isNullLike(it.value)
                      ? this.props.isPercentage
                        ? `${+Big(Number(it.value)).times(100)}%`
                        : it.value
                      : '-'}
                  </span>
                  <br/>
                </>
              ))
          ) : (
            '-'
          )
        ) : (
          <div className="grid grid-cols-7 gap-4 w-full p-2">
            <div className="font-medium text-gray-700 col-span-2 rounded-md">Key</div>
            <div className="font-medium text-gray-700 col-span-2 rounded-md">Value</div>
            {
              this.value.length > 0 ? <>
                <div className='col-span-1'/>
                <div className='col-span-2'/>
              </> : <>
                <div className='col-span-2 flex space-x-2'>
                  <PlusOutlined
                    onClick={this.onAdd.bind(null, 0)}
                  />
                </div>
              </>
            }
            {this.value.map((it, i) => (
              <React.Fragment key={i}>
                <Select
                  value={it.key}
                  onChange={(v: string) =>
                    this.onChange(i, v === '' ? undefined : v, 'key')
                  }
                  options={[
                    { label: 'Daily', value: 'Daily' },
                    { label: 'Short Term', value: 'Short' },
                    { label: 'Regular', value: 'Regular' },
                    { label: 'Long Term', value: 'Long' },
                  ]}
                  className='col-span-2'
                />
                <Num
                  value={it.value}
                  onChange={val => this.onChange(i, { value: val })}
                  onBlur={this.props.onBlur}
                  className='col-span-2'
                />
                <div className='col-span-1'/>
                <div className='col-span-2 flex space-x-2'>
                  <PlusOutlined
                    onClick={this.onAdd.bind(null, i)}
                  />
                  <DeleteOutlined
                    onClick={this.onDel.bind(null, i)}
                  />
                </div>
              </React.Fragment>
            ))}
          </div>
        )}
      </div>
    );
  }
}
